
    <section id="eventos" class="noticias">
      <div class="container">
        <header class="section-header">
          <h3>Nossos Eventos</h3>
          <p>Não Perca!</p>
        </header>

        <app-spinner *ngIf="!eventos"></app-spinner>

        <div class="row noticias-cols" *ngIf="eventos">
          <ng-container *ngIf="eventos.length > 0; else nenhum_evento">
             <div class="col-md-6 wow fadeInUp" *ngFor="let evento of eventos">
              <div class="noticias-col" routerLink="/evento/{{ evento.id }}">
                <div class="container-evento">

                  <!-- Data -->
                  <div class="img">
                    <div class="icon">
                      {{ evento.data | date: "dd/MM" }}
                    </div>
                  </div>

                  <!-- Imagem -->
                  <img
                    [src]="evento.foto ? evento.foto.file : '/assets/img/sem-imagem.png'"
                    [alt]="evento.titulo"
                    class="img-rounded"
                    style="height: 150px; width: 280px; object-fit: cover; border-radius: 0 100px 0 0; background-color: #e8e8e8;"
                  />
                  
                  <!-- Título -->
                  <h2> {{ evento.titulo }}
                  </h2> 
                  <!-- Conteúdo --><br>
                  <div class="conteudo mt-2">
                    <div [innerHTML]="evento.conteudo"></div>
                  </div>

                </div>
              </div>
            </div>
          </ng-container>

          <ng-template #nenhum_evento>
            <div class="col-12">
              <p class="text-center">Nenhum evento a ser exibido.</p>
            </div>
          </ng-template>
        </div>

        <!-- Botão de mais eventos -->
        <div class="text-center" *ngIf="eventos && eventos.length > 0">
          <a routerLink="eventos" class="modern-button mt-4">Mais Eventos</a>
        </div>
      </div>
    </section>
  